import React, { useState, useEffect, useRef, useMemo } from "react";
import Accordion from "react-bootstrap/Accordion";
import Header from "../components/Navbar/Header";
import Navbar from "../components/Navbar";
import Footer from "../components/Navbar/Footer";
import { post, get } from "../utils/helpers/http";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from 'moment';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import interactionPlugin from '@fullcalendar/interaction';
import { Modal, Box, Typography, FormGroup, FormControlLabel, Checkbox, Button, Stack, Select, MenuItem, InputLabel, FormControl } from '@mui/material';


const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  borderRadius: '10px',
  boxShadow: 24,
  p: 4,
}


const ServiceArea = () => {
  const [serviceAreas, setServiceAreas] = useState([]);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [deleteId, setDeleteId] = useState(null);
  const [currentWeek, setCurrentWeek] = useState([]);
  const [startDate, setStartDate] = useState();
  const [endDate, setEndDate] = useState();
  const [openServiceId, setOpenServiceId] = useState();
  const [checkedBoxes, setCheckedBoxes] = useState([]);
  const [errors, setErrors] = useState({});
  const [disableUpdatebtn, setDisableUpdateBtn] = useState(false)
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [open, setOpen] = useState(false);

  const [events, setEvents] = useState([]);
  const [selectedSlots, setSelectedSlots] = useState([]);
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());
  const [selectedTimeSlots, setSelectedTimeSlots] = useState([]);
  const [selectedIdAcordian, setselectedIdAcordian] = useState("");
  const [notAvailableTimeSlot, setnotAvailableTimeSlot] = useState();
  const [allMonthsSelections, setAllMonthsSelections] = useState({});
  const [serviceAreaId, setServiceAreaId] = useState(0);


  useEffect(() => {
  }, [serviceAreaId]);
  const calendarRef = useRef();


  const timeSlots = ['8am - 12pm', '12pm - 4pm', '4pm - 8pm'];


  /**
   * @comment fetch the list of service area
   */


  const timeSlotMapping = {
    1: '8am - 12pm',
    2: '12pm - 4pm',
    3: '4pm - 8pm',
  };

  const fetchServiceAreas = async () => {
    try {
      const response = await get('/ManageService/ServiceAreaList', {});
      console.log("📌 Full API Response:", response.data);

      setServiceAreas(response.data);

      console.log("API Response for Unavailable Slots:", response.data);

      if (response.data?.data) {
        const { notAvailableTimeSlot } = response.data.data;

        if (notAvailableTimeSlot && Array.isArray(notAvailableTimeSlot)) {
          console.log("📌 API Response for Time Slots:", notAvailableTimeSlot);

          const updatedTimeSlots = notAvailableTimeSlot.map(slot => ({
            selectedDate: slot.selectedDate,
            timeSlot: slot.timeSlot
          }));

          console.log("✅ State Updated - Selected Time Slots:", updatedTimeSlots);

          // Update state
          console.log("updatedTimeSlots", updatedTimeSlots);

          setSelectedTimeSlots([...updatedTimeSlots]);

          console.log("updatedTimeSlots One",updatedTimeSlots)
          // Ensure dates are correctly formatted for FullCalendar
          const updatedEvents = updatedTimeSlots.map(slot => ({
            title: `Unavailable (${timeSlotMapping[slot.timeSlot]})`,
            start: moment(slot.selectedDate).format("YYYY-MM-DD"),
            allDay: true,
          }));

          console.log("🗓️ Updated Calendar Events: One:", updatedEvents);
          setEvents(updatedEvents.filter(event => 
            moment(event.start).month() === selectedMonth && 
            moment(event.start).year() === selectedYear
          ));
          
        } else {
          console.log("⚠️ No unavailable time slots found.");
        }
      }
    } catch (error) {
      console.error("❌ Error fetching service areas:", error);
    }
  };

  // Run when component mounts
  useEffect(() => {
    fetchServiceAreas();
    generateCurrentWeek(moment());
  }, []);

  /**
   * @param {*} id 
   * @comment delete service via id
   */
  const handleDeleteServiceArea = async (id) => {
    console.log("id of deleteing service area **", id);
    console.log("id of deleteing service area deleteId **", deleteId);
    // setShowDeleteModal(false);
    try {
      let body = { id: deleteId }
      const response = await post('/ManageService/DeleteServiceArea', body)
      console.log("response ManageService DeleteService Area ******", response)
      fetchServiceAreas();
      toast.success("Service Area deleted successfully");
    } catch (error) {
      console.error("Error deleting service area@@@@@", error);
    } finally {
      setShowDeleteModal(false);
    }
  };

  /**
   * @param {*} id 
   * @param {*} serviceName 
   * @param {*} postCodeFrom 
   * @param {*} postCodeTo 
   * @param {*} notAvailableFullDay 
   * @param {*} notAvailableTimeSlots 
   * @comments update service area
   */





  const handleUpdateServiceArea = async (
    id,
    serviceName,
    postCodeFrom,
    postCodeTo,
    notAvailableFullDay,
    notAvailableTimeSlots,
    selectedDate,
  ) => {
    try {
      console.log("not available time slot , ", notAvailableFullDay, notAvailableTimeSlots);
console.log("fields#",serviceName, postCodeFrom, postCodeTo, selectedDate );

      if (!serviceName || !postCodeFrom || !postCodeTo || !selectedDate) {
        toast.error("Please fill the required fields");
        return;
      }

      const selectedDateObj = new Date(selectedDate);
      // const startDate = new Date(selectedDateObj);
      // startDate.setDate(selectedDateObj.getDate() - selectedDateObj.getDay() + (selectedDateObj.getDay() === 0 ? -6 : 1));
      // const endDate = new Date(startDate);
      // endDate.setDate(startDate.getDate() + 6);
      const startDate = new Date(selectedDateObj.getFullYear(), selectedDateObj.getMonth(), 1);
      const endDate = new Date(
        selectedDateObj.getFullYear(),
        selectedDateObj.getMonth() + 1,
        0,
      );

      const formatDate = (date) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      };

      const formattedStartDate = formatDate(startDate);
      const formattedEndDate = formatDate(endDate);
      console.log("not available time slot , ", selectedTimeSlots, notAvailableTimeSlot);

      // const updateArray = [...selectedTimeSlots, ...notAvailableTimeSlot]; // No duplicate check
      const updateArray = [
        ...new Map(selectedTimeSlots.map((slot) => [JSON.stringify(slot), slot])).values()
      ];
      
      let body = {
        id: id,
        serviceAreaName: serviceName,
        postCodeFrom: postCodeFrom,
        postCodeTo: postCodeTo,
        notAvailableFullDay: notAvailableFullDay,
        dateRangeFrom: formattedStartDate,
        dateRangeTo: formattedEndDate,
        notAvailableTimeSlots: updateArray,
      };

      console.log("upsert service area body ***", body);
      const response = await post("/ManageService/AddUpdateServiceArea", body);
      if (response.data.data) {
        toast.success(response.data.message);
        setServiceAreaId(response.data.data);
        // Keep the accordion open for the updated item
        setOpenServiceId(response.data.data.toString());
        // Refresh the list
        await fetchServiceAreas();
      } else {
        toast.error(response.data.message)
      }
    } catch (error) {
      console.log("upsert service area error ** ", error);
    }
  };

  const handleUpdate = (area) => {
    const selectedCheckboxes = findSelectedCheckboxes();
    handleUpdateServiceArea(
      area.id,     
      area.serviceName,
      area.postCodeFrom,
      area.postCodeTo,
      selectedCheckboxes.length > 0,
      selectedCheckboxes,
      selectedDate
    ).then(() => {
      // Preserve the open accordion
      setOpenServiceId(area.id.toString());
    }).catch(error => {
      console.error("Update failed:", error);
    });
  };

  /**
   * @param {*} area 
   * @comment update service time slot
   */

  
  const addNewArea = () => {
    console.log("before add new service area ** ", serviceAreas);
    const newServiceArea = {
      "id": 0, "serviceName": null, "postCodeFrom": null, "postCodeTo": null, "notAvailableFullDay": false,
      "isActive": true, "isDeleted": false, "createdOn": "", "updatedOn": null, "createdBy": null, "notAvailableTimeSlots": Array(currentWeek.length).fill(false)
    };
  // Reset states
  setServiceAreaId(0);
  setselectedIdAcordian("0");
  setOpenServiceId("0"); // Force close all other accordions
  setEvents([]);
  
  // Add new area
  setServiceAreas(prevServiceAreas => [...prevServiceAreas, newServiceArea]);
  setCheckedBoxes(new Array(currentWeek.length).fill(false));
  }



  /**
   * @param {*} index 
   * @param {*} field 
   * @param {*} value 
   * @comment update input fields // serviceName, postCodeTo postCodeFrom 
   */
  const handleFieldChange = (index, field, value) => {
    const updatedServiceAreas = [...serviceAreas];
    const updatedErrors = { ...errors };
    if (field === 'postCodeFrom' || field === 'postCodeTo') {
      // Allow only numbers and restrict to a max of 4 digits
      if (/^\d{0,4}$/.test(value)) {
        updatedServiceAreas[index][field] = value;
        
        // Remove error only when exactly 4 digits are entered
        updatedErrors[field] = value.length === 4 ? '' : 'Postcode must be exactly 4 digits';
      }
    } else if (field === 'serviceName') {
      const titleCaseValue = value.toLowerCase().replace(/\b(\w)/g, (char) => char.toUpperCase());
      updatedErrors[field] = '';
      updatedServiceAreas[index][field] = titleCaseValue.slice(0, 50);
    } else {
      updatedErrors[field] = '';
      updatedServiceAreas[index][field] = value.slice(0, 50);
    }
    setServiceAreas(updatedServiceAreas);
    setErrors(updatedErrors);
  };

  /**
   * @comment select accordion call api to fecth time slot data
   */
  const handleAccordionSelect = async (selectedIndex) => {

      // If clicking the same accordion, toggle it
  if (openServiceId === selectedIndex) {
    setOpenServiceId(null);
    return;
  }
    setOpenServiceId(selectedIndex);
    console.log(`Accordion item selected ${selectedIndex ? 'API CALL' : ''} :`, selectedIndex);
    setselectedIdAcordian(selectedIndex)

    // Find the corresponding service area to get the correct ID
    const selectedArea = serviceAreas?.find(area => 
        area?.id?.toString() === selectedIndex?.toString()
    );
    
    const areaId = selectedArea ? selectedArea?.id : 0;
    setServiceAreaId(areaId);
    timeSlotList(areaId);
  };
  useEffect(() => {
    timeSlotList()
  }, [startDate, endDate]);


  const timeSlotList = async (id) => {

    try {
      const selectedDateObj = new Date(selectedYear, selectedMonth, 1);

      const startDate = new Date(selectedDateObj.getFullYear(), selectedDateObj.getMonth(), 1);
      const endDate = new Date(selectedDateObj.getFullYear(), selectedDateObj.getMonth() + 1, 0);

      const formatDateToUTC = (date) => {
        return new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), 0, 0, 0)).toISOString();
      };

      const body = {
        id:  id ? id : "",
        from: formatDateToUTC(startDate),
        to: formatDateToUTC(endDate)
      };

      const response = await post("/ManageService/GetServiceAreaDetailById", body);
      console.log(" API Response from GetServiceAreaDetailById:", response);

      // Validate response structure
      if (!response.data || !response.data.data) {
        console.error(" Invalid API response structure:", response);
        return;
      }

      const { notAvailableTimeSlot } = response.data.data;

      if (!notAvailableTimeSlot || !Array.isArray(notAvailableTimeSlot)) {
        setEvents([]);
        return;
      }
      setServiceAreaId(serviceAreaId !== 0 ? serviceAreaId: response?.data?.data?.manageService?.id ?? 0)
      setnotAvailableTimeSlot(notAvailableTimeSlot)
      setSelectedTimeSlots(notAvailableTimeSlot) //set fetch slot from the api

      console.log("📌 Retrieved Not Available Time Slots:", notAvailableTimeSlot);

      // Convert API data into the format required for FullCalendar
      const updatedEvents = notAvailableTimeSlot.map(slot => ({
        title: `Unavailable (${timeSlotMapping[slot.timeSlot]})`,
        start: moment(slot.selectedDate).format("YYYY-MM-DD"),
        allDay: true,
      }));

      console.log("🗓️ Updated Calendar Events: Two", updatedEvents);
      setEvents(updatedEvents);

    } catch (error) {
      console.error("❌ Error fetching service area details:", error);
      setEvents([]);
    }
  };



  useEffect(() => {
    if (calendarRef.current) {
      const calendarApi = calendarRef.current.getApi();
      console.log("Forcing Calendar to:", new Date(selectedYear, selectedMonth, 1));
      calendarApi.gotoDate(new Date(selectedYear, selectedMonth, 1));
    }
  }, [selectedYear, selectedMonth]);

  useEffect(() => {
    const initialDate = moment();
    setCurrentWeek(generateCurrentWeek(initialDate));
    setCheckedBoxes(new Array(7).fill(false));
  }, []);

  const generateCurrentWeek = (date) => {
    const startDate = date.clone().startOf('isoWeek');
    setStartDate(startDate)
    const endDate = date.clone().endOf('isoWeek');
    console.log("startdate$$$", startDate);
    console.log("enddate$$$", endDate);
    setEndDate(endDate)
    const weekDates = [];
    const currentDate = startDate.clone();
    while (currentDate.isSameOrBefore(endDate)) {
      weekDates.push(currentDate.clone());
      currentDate.add(1, 'day');
    }
    return weekDates;
  };
  const findSelectedCheckboxes = () => {
    if (!checkedBoxes || Object.keys(checkedBoxes).length === 0) {
      console.warn("⚠️ Warning: No checkboxes selected!");
      return [];
    }

    const selectedCheckboxes = [];

    for (const key in checkedBoxes) {
      if (checkedBoxes[key]) {
        const [index, slot] = key.split('_');
        const parsedSlot = parseInt(slot);

        if (!currentWeek[index]) {
          console.error(`🚨 Error: currentWeek[${index}] is undefined!`);
          continue; // Skip invalid entries
        }

        selectedCheckboxes.push({
          selectedDate: currentWeek[index].format('YYYY-MM-DDTHH:mm:ss.SSS[Z]'),
          timeSlot: isNaN(parsedSlot) ? null : parsedSlot,
        });
      }
    }

    if (selectedCheckboxes.length === 0) {
      console.warn("⚠️ Warning: No valid checkboxes found!");
    }

    console.log("✅ Selected checkboxes:", selectedCheckboxes);
    return selectedCheckboxes;
  };



  const handleDateClick = (info) => {
    const clickedDate = info.dateStr;
    const isToday = moment(clickedDate).isSame(moment(), 'day');
    
    // If it's today's date, show warning and return
    if (isToday) {
      toast.dismiss();
      toast.error("Cannot modify availability for today's date");
      return;
    }
    setSelectedDate(clickedDate);

    // Find any existing events for this date
    const existingEventsForDate = events.filter(event => event.start === clickedDate);

    // Pre-select the time slots
    const preSelectedSlots = existingEventsForDate.map(event => event.title.replace('Unavailable (', '').replace(')', ''));
    setSelectedSlots(preSelectedSlots);

    setOpen(true);
  };

  const handleSlotChange = (event) => {
    const slot = event.target.name;
    setSelectedSlots(prev =>
      event.target.checked
        ? [...prev, slot]
        : prev.filter(item => item !== slot)
    );
  };
  
  const handleSave = () => {
    const timeSlotMapping = {
      '8am - 12pm': 1,
      '12pm - 4pm': 2,
      '4pm - 8pm': 3,
    };
    
    const sortedSlots = [...selectedSlots].sort((a, b) => timeSlotMapping[a] - timeSlotMapping[b]);
    
    const newEvents = sortedSlots.map(slot => ({
      title: `Unavailable (${slot})`,
      start: selectedDate,
      allDay: true,
    }));
    
    const transformedTimeSlots = sortedSlots.map(slot => ({
      selectedDate: selectedDate + 'T00:00:00',
      timeSlot: timeSlotMapping[slot],
    }));
    
    setEvents(prev => {
      const filteredEvents = prev.filter(event => event.start !== selectedDate);
      
      // Remove duplicate events for the same date
      const uniqueNewEvents = newEvents.filter(newEvent =>
        !filteredEvents.some(existingEvent => 
          existingEvent.start === newEvent.start && existingEvent.title === newEvent.title
        )
      );
    
      return [...filteredEvents, ...uniqueNewEvents];
    });
    
    // Update selected time slots for the current month
    setSelectedTimeSlots(prev => {
      let filteredSlots = prev.filter(slot => slot.selectedDate !== selectedDate + 'T00:00:00');
      
      if (sortedSlots.length === 0) return filteredSlots;
      
      const updatedSlots = [...filteredSlots, ...transformedTimeSlots];
      return Array.from(new Map(updatedSlots.map(slot => [`${slot.selectedDate}-${slot.timeSlot}`, slot])).values());
    });
    
    // IMPORTANT: Store the selections in the all-months state object
    setAllMonthsSelections(prev => {
      // Create a key for the current month and year
      const monthKey = `${selectedYear}-${selectedMonth}`;
      
      // Get existing selections for this month or initialize empty array
      const existingMonthSelections = prev[monthKey] || [];
      
      // Filter out selections for the current date
      const filteredSelections = existingMonthSelections.filter(
        slot => slot.selectedDate !== selectedDate + 'T00:00:00'
      );
      
      // Add new selections
      const updatedSelections = [...filteredSelections, ...transformedTimeSlots];
      
      // Return updated all-months object
      return {
        ...prev,
        [monthKey]: updatedSelections
      };
    });
    
    setSelectedSlots([]);
    setOpen(false);
  };
  
  
  
  
  const handleMonthChange = (event) => {
    const newMonth = parseInt(event.target.value);
    console.log("Selected Month:", newMonth);
    setSelectedMonth(newMonth);
  };


  const handleYearChange = (event) => {
    const newYear = parseInt(event.target.value);
    console.log("Selected Year:", newYear);
    setSelectedYear(newYear);
  };
  console.log('events', events);

  const CustomToolbar = () => {
    return (
      <div style={{ display: 'flex', gap: '1rem', padding: '1rem' }}>
        <FormControl size="small" style={{ minWidth: 120 }}>
          <InputLabel>Month</InputLabel>
          <Select
            value={selectedMonth}
            onChange={handleMonthChange}
            label="Month"
          >
            {[...Array(12)].map((_, i) => (
              <MenuItem key={i} value={i}>
                {new Date(0, i).toLocaleString('default', { month: 'long' })}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl size="small" style={{ minWidth: 120 }}>
          <InputLabel>Year</InputLabel>
          <Select
            value={selectedYear}
            onChange={handleYearChange}
            label="Year"
          >
            {Array.from(
              { length: 10 },
              (_, i) => new Date().getFullYear() - i
            ).map(year => (
              <MenuItem key={year} value={year}>
                {year}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </div>
    );
  };

  const initialDate = (() => {
    return new Date(selectedYear, selectedMonth, 1);
  }, [selectedYear, selectedMonth]);
  console.log(`Re-rendering FullCalendar with key: ${selectedYear}-${selectedMonth}`);


  console.log('initialDate   ===', initialDate)

  return (
    <>
      <Header />
      <div id="wrapper">
        <Navbar />
        <div id="content-wrapper">
          <div className="content_minArea">
            <div className="container-fluid">
              <div className="page-header">
                <div className="lefth">
                  <h1 className="page-title">Manage Service Area</h1>
                </div>
              </div>
              <div className="page-content">
                <Accordion activeKey={openServiceId?.toString()} onSelect={handleAccordionSelect}>
                  {serviceAreas.map((area, index) => (
                    <Accordion.Item key={index} eventKey={area.id.toString()}>
                      <Accordion.Header> {area.serviceName || "New Service Area"}</Accordion.Header>
                      <Accordion.Body>
                        <form>
                          <div className="row">
                            <div className="col-md-6">
                              <div className="form-group mb-3">
                                <label className="form-label">
                                  Service area name <span style={{ color: "red" }}>*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  value={area.serviceName}
                                  maxLength={100}
                                  onChange={(e) => handleFieldChange(index, 'serviceName', e.target.value)}
                                />
                                {errors['serviceName'] && <p className="error-text">{errors['serviceName']}</p>}
                              </div>
                            </div>
                            <div className="col-md-6">
                              <div className="form-group mb-3">
                                <label className="form-label w-100">
                                  Postcode<span style={{ color: "red" }}>*</span>
                                </label>
                                <div className="d-inline-flex postcodefields">
                                  <label className="pe-2 pt-3">From</label>
                                  <input
                                    type="text"
                                    value={area.postCodeFrom}
                                    maxLength={4}
                                    className="form-control"
                                    onChange={(e) => handleFieldChange(index, 'postCodeFrom', e.target.value)}
                                  />
                                  <label className="ps-2 pe-2 pt-3">To</label>
                                  <input
                                    type="text"
                                    value={area.postCodeTo}
                                    className="form-control"
                                    maxLength={4}
                                    onChange={(e) => handleFieldChange(index, 'postCodeTo', e.target.value)}
                                  />
                                </div>
                                <div>
                                  {(errors['postCodeFrom'] || errors['postCodeTo']) && (
                                    <p className="error-text">
                                      {errors['postCodeFrom'] || errors['postCodeTo']}
                                    </p>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <h6>
                            Select dates and time slot when Laundry Go services
                            are <b>not available</b>.
                          </h6>
                          <div className="availabilityCalendar mt-3">
                            <CustomToolbar />
                            <FullCalendar
                              ref={calendarRef}
                              key={`${selectedYear}-${selectedMonth}`}
                              plugins={[dayGridPlugin, interactionPlugin]}
                              initialView="dayGridMonth"
                              initialDate={new Date(selectedYear, selectedMonth, 1)} // Auto-select API date
                              dateClick={(info) => {
                                const today = new Date();
                                today.setHours(0, 0, 0, 0); // Remove time from today

                                const selectedDate = new Date(info.dateStr);
                                selectedDate.setHours(0, 0, 0, 0); // Remove time from selected date

                                console.log("today$$$$", today, selectedDate);

                                if (selectedDate < today) {
                                  return;
                                }
                                handleDateClick(info);
                              }}
                              datesSet={(info) => {
                                console.log("New month detected:", info);
                                const newDate = info.view.currentStart;
                                const newMonth = newDate.getMonth();
                                const newYear = newDate.getFullYear();
                              
                                // Restore previously selected slots for this month
                                const monthKey = `${newYear}-${newMonth}`;
                                const restoredSlots = allMonthsSelections[monthKey] || [];
                                
                                setSelectedTimeSlots(restoredSlots);
                              
                                // Fetch updated slots from the API
                                timeSlotList(selectedIdAcordian, newYear, newMonth);
                                
                                setSelectedMonth(newMonth);
                                setSelectedYear(newYear);
                              }}
                              

                              events={events}
                              height="auto"

                              headerToolbar={{
                                left: '',
                                center: 'title',
                                right: 'prev,next'
                              }}
                              dayCellDidMount={(info) => {
                                const today = new Date();
                                today.setHours(0, 0, 0, 0);
                                const cellDate = new Date(info.date);

                                console.log(`Checking cell: ${cellDate.toDateString()}, Today: ${today.toDateString()}`);

                                if (cellDate < today) {
                                  console.log(`Disabling date: ${cellDate.toDateString()}`); // Debugging log
                                  info.el.classList.add("fc-disabled-date"); // Apply the class only for past dates
                                }

                                const dateString = cellDate.toISOString().split('T')[0];
                                if (events.some(event => event.start === dateString)) {
                                  info.el.classList.add("has-events");
                                }
                              }}
                              eventDidMount={(info) => {
                                // Add tooltip to show time slot
                                info.el.title = info.event.title;

                              }}

                              viewDidMount={(info) => {
                                console.log(info, "infoinfo")
                                // info.view.calendar.gotoDate(new Date(selectedYear, selectedMonth, 1));
                                const currentDate = info.view.currentStart;
                                const newMonth = currentDate.getMonth();
                                const newYear = currentDate.getFullYear();

                                // Check if the month/year has changed
                                if (newMonth !== selectedMonth || newYear !== selectedYear) {
                                  setSelectedMonth(newMonth);
                                  setSelectedYear(newYear);

                                  // Call the API with the new month and year
                                  // timeSlotList();
                                }
                              }}
                            />
                            <Modal
                              open={open}
                              onClose={() => setOpen(false)}
                              aria-labelledby="modal-title"
                              aria-describedby="modal-description"
                            >
                              <Box sx={modalStyle}>
                                <Typography id="modal-title" variant="h6" component="h2" gutterBottom>
                                  Select Unavailable Time Slots
                                </Typography>
                                <FormGroup>
                                  {timeSlots.map((slot, index) => (
                                    <FormControlLabel
                                      key={index}
                                      control={
                                        <Checkbox
                                          checked={selectedSlots.includes(slot)}
                                          onChange={handleSlotChange}
                                          name={slot}
                                        />
                                      }
                                      label={slot}
                                    />
                                  ))}
                                </FormGroup>
                                <Button
                                  variant="contained"
                                  color="primary"
                                  onClick={handleSave}
                                  disabled={false }
                                  sx={{ mt: 2 }}
                                  fullWidth
                                >
                                  OK
                                </Button>
                              </Box>
                            </Modal>
                          </div>
                          <div className="mt-4 text-end">
                            <button className="btn btn-default deletebutton" type="button"
                              onClick={() => {
                                 setShowDeleteModal(true);
                                  setDeleteId(area.id); 
                              }}
                            > Delete </button>
                            <button
                              className="btn btn-primary"
                              type="button"
                              onClick={() => handleUpdate(area)}
                              disabled={disableUpdatebtn} >
                              Update
                            </button>
                          </div>
                        </form>
                      </Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>
                <button className="addbutton mt-2" onClick={() => addNewArea()}>
                  + Add New Service Area
                </button>
              </div>
            </div>
          </div>
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
            closeOnClick
            pauseOnHover
            draggable
            onOpen={() => {
              setDisableUpdateBtn(true);
              setTimeout(() => {
                setDisableUpdateBtn(false);
              }, 5000);
            }}
          />
          <Footer />
        </div>
      </div>
      {showDeleteModal && (
        <div className="modal" tabIndex="-1" role="dialog" style={{ display: "block", backgroundColor: "rgba(0,0,0,0.5)" }}>
          <div className="modal-dialog" role="document">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Delete service area Confirmation</h5>
                <button type="button" onClick={() => setShowDeleteModal(false)}></button>
              </div>
              <div className="modal-body">
                <p>Are you sure you want to delete this service area?</p>
              </div>
              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={() => setShowDeleteModal(false)}>Cancel</button>
                <button type="button" className="btn btn-primary" onClick={handleDeleteServiceArea}>Yes</button>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default ServiceArea;
